export default __webpack_public_path__ + "e21fda72f7303338832c8d53c0b4cb05.woff2";